// Logout

import { useDispatch } from "custom_exports/all_hooks";
import { IconButton } from "custom_exports/material_ui_items";
import { MdPowerSettingsNew } from "react-icons/md";
import logout from "utils/logout";

function Logout() {
	//--------------------------------- variables ---------------------------------//
	const dispatch = useDispatch();

	//--------------------------------- functions ---------------------------------//
	// ---- handlers ---- //
	const handleOnClick = (event) => {
		logout({ dispatch });
	};
	//--------------------------------- contents ----------------------------------//
	const content = (
		<IconButton onClick={handleOnClick}>
			<MdPowerSettingsNew />
		</IconButton>
	);

	return content;
}

export default Logout;
